module.exports = __webpack_public_path__ + "static/media/corona_0.7fd8286f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corona_0.jpg
// module id = 1018
// module chunks = 0